// extracted by mini-css-extract-plugin
export var active = "_bt-2";
export var recordingDot = "_bt-1";
export var recordingIndicator = "_bt-0";